var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { isNull } from 'lodash';
import { ELSLoggingService } from 'components/common';
import ResponsiveTable from 'components/common/responsive-table/ResponsiveTable';
import TableFilter from 'components/common/table-filter/TableFilter';
import { FeatureFlagNames, SORT_DIRECTION } from 'constants/app.constant';
import { pluralizeUnit, renderNoResultsFound } from 'helpers/ui.helper';
import { ASSIGNMENT_TYPE_GROUPS, ENGAGEMENT_TABLE_SELECTOR, getAssignmentTypeById, STUDENT_ENGAGEMENT_TABLE_SELECTOR } from 'reports/cw/constants/report.constant';
import { isEABAssignment } from 'reports/cw/helpers/report.helper';
import { renderAvgTimeSpent } from 'reports/cw/helpers/student-assignment.helper';
import { cwActions, cwSelectors } from 'reports/cw/redux/ducks/cw';
import { remapFieldsForEngagementReport } from 'reports/cw/services/report.service';
import { appSelectors } from 'redux/ducks/app';
import { filterActions, filterSelectors } from 'redux/ducks/filter';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { triggerSortTableManually, dispatchScrollToTableEvent, getSortingColumnSelector, classActions, actionFlashPromise, waitForFlashAnimationEnd } from 'services/table.service';
import { renderAvgTimePerQuestion, renderAvgTimePerQuestionComparedToClass, renderStudentTotalGradePoints, renderTotalLogins, renderTotalSelfStudyTime } from '../../student-engagement/student-engagement-table-helper/StudentEngagementTableHelper';
import { renderAssignmentsBelowClassAvg, renderAverageScore, renderLastLogin, renderName, renderPastDue, compareDisengagedStudent, FLASH_CLASS } from './engagement-table-helper/EngagementTableHelper';
export var getEngagementColumns = function (_a) {
    var isEAQAssignmentType = _a.isEAQAssignmentType, isStudentTotalGradePointsHidden = _a.isStudentTotalGradePointsHidden, featureFlags = _a.featureFlags;
    var gradePointsColumns = isStudentTotalGradePointsHidden
        ? []
        : [
            {
                field: 'totalGradePoints',
                header: 'Student Total Grade Points',
                customRender: function (row) { return renderStudentTotalGradePoints(row, featureFlags); },
                minWidth: 150,
                align: 'right'
            }
        ];
    var eaqQuestionColumns = isEAQAssignmentType
        ? [
            {
                field: 'numberOfAssignedQuestionsAttempted',
                header: '# Assigned Questions Attempted'
            },
            {
                field: 'numberOfSelfStudyQuestionsAttempted',
                header: '# Self-Study Questions Attempted',
                headerCssModifier: STUDENT_ENGAGEMENT_TABLE_SELECTOR.selfStudyQuestionsAttemptedColumn
            }
        ]
        : [];
    var eaqTimeColumns = isEAQAssignmentType
        ? [
            {
                field: 'avgTimePerQuestionSeconds',
                header: 'Avg Time per Question',
                customRender: renderAvgTimePerQuestion
            },
            {
                field: 'avgTimePerQuestionComparedToClassAvgSeconds',
                header: 'Avg Time per Question Compared to Class Avg',
                headerCssModifier: STUDENT_ENGAGEMENT_TABLE_SELECTOR.timeSpentComparedToClassAvgColumn,
                customRender: renderAvgTimePerQuestionComparedToClass
            }
        ]
        : [];
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            field: 'studentName',
            header: 'Student',
            customRender: renderName,
            minWidth: 250
        },
        {
            field: 'percentAvgScore',
            header: 'Average Score',
            headerCssModifier: ENGAGEMENT_TABLE_SELECTOR.averageScoreColumn,
            customRender: renderAverageScore,
            sortNARecordInBottom: true
        }
    ], gradePointsColumns, true), eaqQuestionColumns, true), [
        {
            field: 'pastDue',
            header: '# Past Due',
            headerCssModifier: ENGAGEMENT_TABLE_SELECTOR.pastDueColumn,
            customRender: renderPastDue
        },
        {
            field: 'totalAssignmentsBelowClassAvg',
            header: '# Assignments below Class Avg',
            headerCssModifier: ENGAGEMENT_TABLE_SELECTOR.belowClassAvgColumn,
            customRender: renderAssignmentsBelowClassAvg
        },
        {
            field: 'avgTimeSpent',
            header: 'Average Time Spent per Assignment',
            customRender: renderAvgTimeSpent
        }
    ], false), eaqTimeColumns, true), [
        {
            field: 'totalLogins',
            header: 'Total Logins',
            customRender: renderTotalLogins
        },
        {
            field: 'lastLogin',
            header: 'Last Login',
            customRender: renderLastLogin
        },
        {
            field: 'totalTimeSpentOnSelfStudySeconds',
            header: 'Total Self Study Time',
            customRender: renderTotalSelfStudyTime
        }
    ], false);
};
export var EngagementTable = function (_a) {
    var _b, _c;
    var assignmentTypeId = _a.assignmentTypeId, filteredAssignmentEngagement = _a.filteredAssignmentEngagement, studentEngagement = _a.studentEngagement, searchKeyword = _a.searchKeyword, studentEngagementSort = _a.studentEngagementSort, featureFlags = _a.featureFlags, setSearchKeyword = _a.setSearchKeyword, setStudentEngagementSort = _a.setStudentEngagementSort;
    var _d = useState(null), currentSortField = _d[0], setCurrentSortField = _d[1];
    // Local, one-shot copy of the redux interaction that actually drives the flash animation.
    // The redux flag itself is cleared as soon as it's read (see effect below) so that
    // remounting this table (e.g. switching assignment type) never replays a stale interaction.
    var _e = useState(null), flashingInteraction = _e[0], setFlashingInteraction = _e[1];
    // The "Disengaged Students" card reorders the data by isAtRiskStudent directly, instead of
    // simulating a column-header click, so no column's active-sort state/icon is ever touched.
    // remountKey forces ResponsiveTable to reinitialize its internal sort state (see defaultSortField
    // below) rather than keep whatever column was previously actively sorted.
    var _f = useState(false), manualDisengagedSortActive = _f[0], setManualDisengagedSortActive = _f[1];
    var _g = useState(0), remountKey = _g[0], setRemountKey = _g[1];
    var _h = studentEngagement || {}, avgTimeOfClassOnQuestions = _h.avgTimeOfClassOnQuestions, _j = _h.metrics, metrics = _j === void 0 ? [] : _j;
    var isEAQAssignmentType = ((_b = getAssignmentTypeById(assignmentTypeId)) === null || _b === void 0 ? void 0 : _b.group) === ASSIGNMENT_TYPE_GROUPS.EAQ;
    var isGradePointsEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_GRADE_WEIGHTING_SCORE_ENABLED);
    var isStudentTotalGradePointsHidden = !isGradePointsEnabled || (isEABAssignment(assignmentTypeId) && isFeatureEnabled(featureFlags, FeatureFlagNames.EAB_GRADEPOINTS_ENABLED));
    var columns = useMemo(function () { return getEngagementColumns({ isEAQAssignmentType: isEAQAssignmentType, isStudentTotalGradePointsHidden: isStudentTotalGradePointsHidden, featureFlags: featureFlags }); }, [isEAQAssignmentType, isStudentTotalGradePointsHidden, featureFlags]);
    var getCurrentSortStatus = function (sortField) {
        // Every call here comes from a genuine header click (the manual reorder never simulates one),
        // so any click means the user took over — drop back to the table's normal sort behavior.
        setManualDisengagedSortActive(false);
        setCurrentSortField(sortField);
    };
    var tableProps = {
        cssModifier: 'u-els-margin-top-2x c-cw-engagement-table',
        // 'isAtRiskStudent' isn't a real column, so ResponsiveTable shows no active-sort icon on any
        // column and leaves the (already manually-ordered) records untouched — see sortRecords in
        // ResponsiveTable.tsx, which passes records through as-is when no column matches the field.
        defaultSortField: manualDisengagedSortActive ? 'isAtRiskStudent' : 'percentAvgScore',
        defaultSortDirection: SORT_DIRECTION.ASC,
        getCurrentSortStatus: getCurrentSortStatus
    };
    var onFlashColumnCleanup = function () { return __awaiter(void 0, void 0, void 0, function () {
        var wrappers, promises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    wrappers = Array.from(document.querySelectorAll(".".concat(FLASH_CLASS)));
                    promises = wrappers.map(actionFlashPromise(FLASH_CLASS, classActions.REMOVE));
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // Resolves once the flash has visually finished playing (driven by the CSS animationend event,
    // not a duplicated JS timer), so callers know when it's safe to clear the flash state/classes.
    var onFlashColumnTrigger = function (interaction) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, columnIndex, _a, headerSelector, bodySelector, headerWrapper, bodyWrappers, wrappers;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onFlashColumnCleanup()];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    ELSLoggingService.error('Error during onFlashColumnCleanup', e_1);
                    return [3 /*break*/, 3];
                case 3:
                    columnIndex = columns.findIndex(function (column) { return column.field === interaction.field; });
                    if (columnIndex === -1) {
                        return [2 /*return*/];
                    }
                    _a = getSortingColumnSelector(columnIndex + 1), headerSelector = _a.header, bodySelector = _a.body;
                    headerWrapper = document.querySelector(headerSelector);
                    bodyWrappers = Array.from(document.querySelectorAll(bodySelector));
                    wrappers = __spreadArray(__spreadArray([], bodyWrappers, true), [headerWrapper], false).filter(Boolean);
                    return [4 /*yield*/, Promise.all(wrappers.map(actionFlashPromise(FLASH_CLASS, classActions.ADD)))];
                case 4:
                    _b.sent();
                    return [4 /*yield*/, Promise.all(wrappers.map(waitForFlashAnimationEnd))];
                case 5:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (flashingInteraction && !isNull(currentSortField) && currentSortField !== flashingInteraction.field) {
            setFlashingInteraction(null);
        }
    }, [currentSortField]);
    useEffect(function () {
        if (studentEngagementSort) {
            if (studentEngagementSort.manualSort) {
                setManualDisengagedSortActive(true);
                setRemountKey(function (key) { return key + 1; });
                dispatchScrollToTableEvent();
            }
            else {
                triggerSortTableManually(studentEngagementSort.sortDirection, ".".concat(studentEngagementSort.columnHeaderSelector));
            }
            setFlashingInteraction(studentEngagementSort);
            setStudentEngagementSort(null);
        }
    }, [studentEngagementSort]);
    useEffect(function () {
        if (!flashingInteraction) {
            onFlashColumnCleanup();
            return undefined;
        }
        var isStale = false;
        onFlashColumnTrigger(flashingInteraction).then(function () {
            if (!isStale) {
                onFlashColumnCleanup();
                setFlashingInteraction(null);
            }
        });
        return function () {
            isStale = true;
        };
    }, [flashingInteraction]);
    useEffect(function () {
        return function () {
            onFlashColumnCleanup();
        };
    }, []);
    var tableData = metrics
        .map(function (item) { return remapFieldsForEngagementReport(item, avgTimeOfClassOnQuestions, isEAQAssignmentType); })
        .filter(function (item) { return item.studentName.toLowerCase().includes(searchKeyword.toLowerCase().trim()); });
    if (manualDisengagedSortActive) {
        tableData = __spreadArray([], tableData, true).sort(compareDisengagedStudent);
    }
    var numberOfStudents = tableData.length;
    var numberOfAssignments = filteredAssignmentEngagement.length;
    return (<div className="c-cw-engagement-table-wrapper">
      <TableFilter filterHidden searchKeyword={searchKeyword} onSearch={setSearchKeyword} searchPlaceholder="Start search..." customClass="c-cw-engagement-table__filter u-els-margin-top-2x u-els-margin-bottom-2x u-els-margin-bottom-1x@mobile">
        <h4 className="c-cw-engagement-table__header">
          <span>{"Showing "}</span>
          <strong>{numberOfStudents}</strong>
          <span>{" ".concat(pluralizeUnit(numberOfStudents, 'student'), " engagement across ")}</span>
          <strong>{"".concat(numberOfAssignments, " ").concat((_c = getAssignmentTypeById(assignmentTypeId)) === null || _c === void 0 ? void 0 : _c.name, " ")}</strong>
          <span>{"".concat(pluralizeUnit(numberOfAssignments, 'assignment'), ", including self study")}</span>
        </h4>
      </TableFilter>
      <ResponsiveTable key={remountKey} columns={columns} records={tableData} tableProps={tableProps}/>
      {tableData.length === 0 && renderNoResultsFound()}
    </div>);
};
var mapStateToProps = function (state) { return ({
    studentEngagement: cwSelectors.getStudentEngagement(state),
    studentEngagementSort: cwSelectors.getStudentEngagementSort(state),
    searchKeyword: filterSelectors.getCWStudentEngagementTableSearch(state),
    featureFlags: appSelectors.getFeatureFlags(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    setSearchKeyword: function (searchKeyword) { return dispatch(filterActions.setCWStudentEngagementTableSearch(searchKeyword)); },
    setStudentEngagementSort: function (data) { return dispatch(cwActions.setStudentEngagementSort(data)); }
}); };
export { EngagementTable as EngagementTableBase };
export default connect(mapStateToProps, mapDispatchToProps)(EngagementTable);
